import { useMutation } from '@tanstack/react-query';
import { START_INTEGRATION_CONNECTION } from '../documents';
import {
  IntegrationWorkspaceVariables,
  StartIntegrationConnectionInput,
  StartIntegrationConnectionResult,
} from '../types';
import {
  integrationAuthError,
  useIntegrationAuthFetcher,
} from './useIntegrationAuthFetcher';

interface StartResponse {
  integrationAuth: { startConnection: StartIntegrationConnectionResult } | null;
}

export const useStartIntegrationConnection = (
  workspaceId: string | undefined
) => {
  const fetcher = useIntegrationAuthFetcher<
    StartResponse,
    StartIntegrationConnectionInput & IntegrationWorkspaceVariables
  >(START_INTEGRATION_CONNECTION);
  return useMutation({
    retry: false,
    gcTime: 0,
    mutationFn: async (
      input: StartIntegrationConnectionInput
    ): Promise<StartIntegrationConnectionResult> => {
      if (!workspaceId) throw integrationAuthError();
      const data = await fetcher({ ...input, workspaceId });
      if (!data.integrationAuth) throw integrationAuthError();
      return data.integrationAuth.startConnection;
    },
  });
};
